<template>
		<div class="card cardptpr mb-4">
			<div class="card-header p-3 pb-0 pt-0">
				<H6>{{this.title}}</H6>
			</div>
			<div class="card-body p-3 pt-0">
                <div class="row mt-2">
                    <div class="col-md-4 mb-0 me-4">
                        <el-radio-group v-model="charttype">
                            <el-radio label="barchart" size="small">Bar Chart</el-radio>
                            <el-radio label="linechart" size="small">Line Chart</el-radio>
                        </el-radio-group>
                    </div>
                    <div class="col-md-1 me-4" v-if="false && charttype=='barchart'"><el-checkbox v-model="stacked">Stacked</el-checkbox> </div>
                    <div class="col-md-1"><el-checkbox v-model="showValue">Show Value</el-checkbox> </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <BarChart v-if="charttype=='barchart'" :data="this.data" :width="this.width" :height="this.height" :url="this.url" :tooltipaftertitle="this.tooltipaftertitle" :showValue="showValue"/>
                        <LineChart v-if="charttype=='linechart'" :data="this.data" :width="this.width" :height="this.height" :url="this.url" class="mt-4" :showValue="showValue"/>
                    </div>
                </div>
			</div>

			<Loader v-if="loading" />

		</div>
</template>

<script>
import BarChart from '@/components/chart/BarChart2.js'
import LineChart from '@/components/chart/LineChart2.js'
import Loader from '@/components/loader/Loader2.vue'

export default{
	props:["data", "title", "width", "height", "url", "tooltipaftertitle", "loading"], //additional: tooltipaftertitle, loading
	components:{
		BarChart,
        LineChart,
		Loader
	},
    mounted(){
    },
    data(){
		return {
            charttype: 'barchart',
            showValue: false,
            stacked: true,
        }
    },
    methods:{
	}
}

</script>
